import script from "./legoSwitchExtend.vue?vue&type=script&lang=js"
export * from "./legoSwitchExtend.vue?vue&type=script&lang=js"

import "./legoSwitchExtend.vue?vue&type=style&index=0&id=80e684b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80e684b4"],['__file',"src/components/lego/extend/legoSwitchExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80e684b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80e684b4', __exports__)) {
    api.reload('80e684b4', __exports__)
  }
  
}


export default __exports__